/* eslint-disable no-template-curly-in-string */
import { Menu, MenuItem } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
  PROFILE_PUFV_ASSESSOR_PEDAGOGICO,
  PROFILE_PUFV_COORDENADOR_LOCAL,
  PROFILE_PUFV_OPERACIONAL,
  PROFILE_PUFV_PROFESSOR,
  PROFILE_PUFV_PROFESSOR_GESTOR,
  PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR,
} from '../../library/Profiles';
import { contratosRoute, projetosRoute, toLogout } from '../../library/Routes';
import { resetAssessoresReducer } from '../../store/modules/AssessoresActions';
import { resetCoordenadoresReducer } from '../../store/modules/CoordenadoresActions';
import { resetEscolasReducer } from '../../store/modules/EscolasActions';
import { resetLogradouroReducer } from '../../store/modules/LogradouroActions';
import { openModal } from '../../store/modules/ModalActions';
import { resetProfessoresReducer } from '../../store/modules/ProfessoresActions';
import { resetProjetosReducer } from '../../store/modules/ProjetoActions';
import { getElementID } from '../../utils/HTMLUtils';
import { AssessorEditModal } from '../AssessorEditModal';
import { CoordenadorEditModal } from '../CoordenadorEditModal';
import { fetchNotifications } from '../../store/modules/NotificationsActions';
import EditIcon from '../Icons/EditIcon';
import ExitToAppIcon from '../Icons/ExitToAppIcon';
import { ProfessorEditModal } from '../ProfessorEditModal';
import { toOpen } from './../LeftSidebar/LeftSidebarActions';
import styles from './Navbar.scss';
import NotificationIcon from 'assets/icons/NotificationIcon';
import Notifications from '../../components/Notifications';
import { LogoProgramasEducacionais } from 'components/LogoProgramasEducacionais/LogoProgramasEducacionais';

const rootClassName = styles.rootClassName;
const rootElementId = 'navbar';
class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileMenuOpened: false,
      profileMenuAnchorEl: null,
      anchorNotificationEl: null,
    };
  }

  componentDidMount() {
    window.addEventListener('storage', this.handleLocalStorageChange);
    const notificationCount =
      parseInt(localStorage.getItem('notificationCount'), 10) || 0;
    this.setState({ badgeCount: notificationCount });
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleLocalStorageChange);
  }

  componentDidUpdate(prevProps) {
    if (this.props.notifications !== prevProps.notifications) {
      this.setState({ notificationsT: this.props.notifications });
      const notificationCount = this.props.notifications.length;
      this.setState({ badgeCount: notificationCount });
      localStorage.setItem('notificationCount', notificationCount.toString());
    }
  }

  handleLocalStorageChange = (event) => {
    if (event.key === 'notificationCount') {
      this.setState({ badgeCount: parseInt(event.newValue, 10) });
    }
  };

  toOpenProfileMenu = (event) => {
    this.setState({
      ...this.state,
      profileMenuOpened: true,
      profileMenuAnchorEl: event.currentTarget,
    });
  };

  toCloseProfileMenu = () => {
    this.setState({
      ...this.state,
      profileMenuOpened: false,
    });
  };

  toOpenProfessorEditModal = () => {
    this.props.openModal(ProfessorEditModal, {
      cpf: this.props.auth.userData.cpf,
    });
  };

  toOpenCoordenadorEditModal = () => {
    this.props.openModal(CoordenadorEditModal, {
      cpf: this.props.auth.userData.cpf,
    });
  };

  toOpenAssessorEditModal = () => {
    this.props.openModal(AssessorEditModal, {
      cpf: this.props.auth.userData.cpf,
    });
  };

  toEditProfile = () => {
    this.toCloseProfileMenu();
    switch (this.props.auth.userData.perfil) {
      case PROFILE_PUFV_PROFESSOR.id:
      case PROFILE_PUFV_PROFESSOR_GESTOR.id:
        this.toOpenProfessorEditModal();
        return;
      case PROFILE_PUFV_COORDENADOR_LOCAL.id:
        this.toOpenCoordenadorEditModal();
        return;
      case PROFILE_PUFV_ASSESSOR_PEDAGOGICO.id:
      case PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR.id:
        this.toOpenAssessorEditModal();
        return;
      default:
        return;
    }
  };

  toHomePage = () => {
    this.props.auth.userData.perfil === PROFILE_PUFV_OPERACIONAL.id
      ? this.props.history.push(contratosRoute.path)
      : this.props.history.push(projetosRoute.path);
  };

  toLogout = () => {
    this.toCloseProfileMenu();
    toLogout(this.props.history);
  };

  toOpenNotificationsMenu = (event) => {
    this.setState({ anchorNotificationEl: event.currentTarget });
    this.props.fetchNotifications();
  };

  toCloseNotificationsMenu = () => {
    this.setState({ anchorNotificationEl: null });
    this.props.fetchNotifications();
  };

  checkCurrentPage = () => {
    const { currentPage, totalPages } = this.props;
    if (currentPage >= totalPages) {
      this.setState({ currentPage: Math.max(totalPages - 1, 0) }, () => {
        this.props.fetchNotifications();
      });
    }
  };

  shouldDisplayBadge = () => {
    const { notifications } = this.props;
    const localStorageCount = parseInt(
      localStorage.getItem('notificationCount'),
      10
    );
    return notifications.length > 0 || localStorageCount > 0;
  };

  render() {
    const shouldDisplayBadge = this.shouldDisplayBadge();
    return this.props.auth.userPermissions.navbar.view ? (
      <AppBar
        position='fixed'
        className={rootClassName}
        id={getElementID(rootElementId, 'container')}
      >
        <Toolbar className={rootClassName + '-toolbar'}>
          <div className={rootClassName + '-left-toolbar'}>
            <IconButton
              id={getElementID(rootElementId, 'left-menu-toggle')}
              className={rootClassName + '-icon-button'}
              aria-label='Menu'
              onClick={this.props.toOpen}
            >
              <MenuIcon className={rootClassName + '-menu-icon'} />
            </IconButton>
            <button
              id={getElementID(rootElementId, 'logo')}
              className={rootClassName + '-logo-pufv-button'}
              onClick={() => {
                this.toHomePage();
              }}
            >
              <LogoProgramasEducacionais />
            </button>
          </div>
          <div className={rootClassName + '-right-toolbar'}>
            <button
              onClick={this.toOpenNotificationsMenu}
              style={{ cursor: 'pointer' }}
            >
              <NotificationIcon />
              {shouldDisplayBadge && <div className='notification-badge'></div>}
            </button>

            <IconButton
              id={getElementID(rootElementId, 'right-menu-toggle')}
              className={rootClassName + '-icon-button'}
              aria-label='Menu'
              onClick={this.toOpenProfileMenu}
            >
              <AccountCircle className={rootClassName + '-menu-icon'} />
            </IconButton>
            <Menu
              anchorEl={this.state.profileMenuAnchorEl}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={this.state.profileMenuOpened}
              onClose={this.toCloseProfileMenu}
            >
              {this.props.auth.userData && this.props.auth.userData.nome ? (
                <MenuItem
                  id={getElementID(rootElementId, 'right-menu-item-name')}
                  className={rootClassName + '-profile-menu-item'}
                  disabled={true}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: this.props.languageValues.profileMenuItemHello
                        .split('${1}')
                        .join(this.props.auth.userData.nome.split(' ')[0]),
                    }}
                  ></span>
                </MenuItem>
              ) : null}
              {this.props.auth.userPermissions.navbar.profile.edit ? (
                <MenuItem
                  id={getElementID(rootElementId, 'right-menu-item-profile')}
                  className={rootClassName + '-profile-menu-item'}
                  onClick={this.toEditProfile}
                >
                  <EditIcon className={rootClassName + '-profile-menu-icon'} />
                  {this.props.languageValues.profileMenuItemEdit}
                </MenuItem>
              ) : null}
              <MenuItem
                id={getElementID(rootElementId, 'right-menu-item-logout')}
                className={rootClassName + '-profile-menu-item'}
                onClick={this.toLogout}
              >
                <ExitToAppIcon
                  className={rootClassName + '-profile-menu-icon'}
                />
                {this.props.languageValues.profileMenuItemLogout}
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
        <Notifications
          anchorNotificationEl={this.state.anchorNotificationEl}
          toCloseNotificationsMenu={this.toCloseNotificationsMenu}
        />
      </AppBar>
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
  notifications: state.notifications.notifications,
  currentPage: state.notifications.currentPage,
  totalNotifications: state.notifications.totalNotifications,
  totalPages: state.notifications.totalPages,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toOpen,
      toLogout,
      openModal,
      resetAssessoresReducer,
      resetCoordenadoresReducer,
      resetEscolasReducer,
      resetLogradouroReducer,
      resetProfessoresReducer,
      resetProjetosReducer,
      fetchNotifications,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Navbar));
